(function () {


    angular.module('ib-monetate-checkin-module', []);
})();
